module.exports = `${require.publicPath}home-img06.e82c153b.png`;